export const TEAM = [
    {
        initials: 'Gal Saar',
        post: 'CEO',
        image: '/img/team/gal_saar.jpg',
        linkedIn: 'https://www.linkedin.com/in/gal-saar-7718491/'
    },
    {
        initials: 'Frank Stephenson',
        post: 'Lead Designer',
        image: '/img/team/frank_stephenson.jpeg',
        linkedIn: 'https://www.linkedin.com/in/frank-stephenson-7298546/'
    },
    {
        initials: 'Nir Navon',
        post: 'CTO',
        image: '/img/team/nir_navon.jpg',
        linkedIn: 'https://www.linkedin.com/in/nir-navon/'
    },
    {
        initials: 'Dr. Zakhar (Zacki) Nudelman',
        post: 'VP Scientific Affairs and BD',
        image: '/img/team/zakhar_nudelman.jpg',
        linkedIn: 'https://www.linkedin.com/in/zakhar-zacki-nudelman-phd-mba-95773642/'
    },
    {
        initials: 'Gilad Nahmias',
        post: 'Manufacturing Manager',
        image: '/img/team/gilad_nahmias.jpeg',
        linkedIn: 'https://www.linkedin.com/in/gilad-nahmias-b5aa5860/'
    },
    {
        initials: 'Haggai Klorman',
        post: 'Advisory Board',
        image: '/img/team/haggai_klorman.jpg',
        linkedIn: 'https://www.linkedin.com/in/klormaneraqi/'
    },
    {
        initials: 'Vika Green',
        post: 'VP Marketing',
        image: '/img/team/vika_green.jpg',
        linkedIn: 'https://www.linkedin.com/in/vika-green-83030a19/'
    },
    {
        initials: 'Nufar Sapir',
        post: 'Creative Marketing',
        image: '/img/team/nufar_sapir.jpg',
        linkedIn: 'https://www.linkedin.com/in/nufar-sapir-0bb5b414/'
    },
    {
        initials: 'Effi Tahar',
        post: 'VP Engineering',
        image: '/img/team/effi_tahar.jpeg',
        linkedIn: 'https://www.linkedin.com/in/effi-tahar-80357744/'
    },
    {
        initials: 'Ido Gedanken',
        post: 'Product Manager',
        image: '/img/team/ido_gedanken.jpg',
        linkedIn: 'https://www.linkedin.com/in/ido-gedanken-00a6a6222/'
    },
    {
        initials: 'Tamar Levin',
        post: 'Backend Team Leader',
        image: '/img/team/tamar_levin.jpeg',
        linkedIn: 'https://www.linkedin.com/in/tamar-levin-520972/'
    },
    {
        initials: 'Guy Isakov',
        post: 'Frontend Team Leader',
        image: '/img/team/guy_isakov.jpg',
        linkedIn: 'https://www.linkedin.com/in/guy-isakov-58280a96/'
    },
    {
        initials: 'Neta Beresheet',
        post: 'Marketing and Biz Dev',
        image: '/img/team/neta_beresheet.jpeg',
        linkedIn: 'https://www.linkedin.com/in/neta-beresheet-084948229/'
    },
    
    {
        initials: 'Asaf Hagani',
        post: 'Software Developer',
        image: '/img/team/asaf_hagani.jpeg',
        linkedIn: 'https://www.linkedin.com/in/asaf-hagany-089196225/'
    },
    {
        initials: 'Ilia Kaplun',
        post: 'Industrial design & prototyping management',
        image: '/img/team/ilia_kaplun.jpeg',
        linkedIn: 'https://www.linkedin.com/in/ilia-kaplun-b7786b19/'
    }
    
]
